import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import Global from '../../../../../store/global-selectors';
import GetCarrierDisplayName from '../../../../../components/data-driven-logo/get-carrier-display-name';
import PackageDropdown from '../package-dropdown';
import { useSelector } from 'react-redux';

const buildCustomPackages = (packages) => {
  return packages.filter((pkg) => pkg.isCustom && !pkg.isHidden).sort((a, b) => a.name.localeCompare(b.name));
};

const getCarrierPackages = (packages = [], carrier = {}) => {
  const carrierPackages = packages.filter((pkg) => pkg.carrierId === carrier.carrierId && !pkg.isHidden);
  return [
    {
      id: carrier?.carrierId,
      groupName: GetCarrierDisplayName(carrier?.carrierId),
      packages: carrierPackages,
    },
  ];
};

const PackageDropdownContainer = ({ selectedPackageId, onPackageSelected = noop, carrierId }) => {
  const packages = useSelector(Global.selectSellerPackages);
  const carrier = useSelector(Global.selectReferenceDatagetSellerCarriers).find((car) => car.carrierId === carrierId);

  const groupedPackages = useMemo(() => getCarrierPackages(packages, carrier), [packages, carrier]);
  const customPackages = useMemo(() => buildCustomPackages(packages), [packages]);
  const {
    name,
    carrierId: packageCarrierId,
    isCustom,
  } = useMemo(() => packages.find((pck) => pck.packageId === selectedPackageId), [packages, selectedPackageId]) ?? {};

  useEffect(() => {
    if (packageCarrierId !== carrierId && !isCustom) {
      onPackageSelected('');
    }
  }, [carrierId, onPackageSelected, packageCarrierId, isCustom]);

  return (
    <PackageDropdown
      customPackages={customPackages}
      groupedPackages={groupedPackages}
      onPackageSelected={onPackageSelected}
      selectedPackageId={selectedPackageId}
      selectedPackageName={name}
    />
  );
};

PackageDropdownContainer.propTypes = {
  onPackageSelected: PropTypes.func,
  selectedPackageId: PropTypes.string,
  carrierId: PropTypes.string,
};

export default PackageDropdownContainer;
